export const caloAddress = '0xb6b91269413b6B99242B1c0Bc611031529999999';
export const fitAddress = '0x77922a521182a719a48ba650ac2a040269888888';
